import * as React from 'react';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import imgGastroHepato from '../../assets/imggastroEsp.png'

export default function ImgMediaCard(props) {
  return (
    <Card sx={{ maxWidth: 345, minWidth: 250, margin: 2}}>
      <CardMedia
        component="img"
        alt="green iguana"
        height="90"
        image={imgGastroHepato}
        sx={{opacity:1}}

      />
      <CardContent sx={{height:10, display:'flex', justifyContent:'center', alignContent:'center'}}>
        <Typography gutterBottom variant="h5" component="div" sx={{fontFamily:'Lucida Sans', fontSize:16, fontWeight:'bold', color:'#07498b'}}>
          {props.texto1}
        </Typography>
       
      </CardContent>    
    </Card>
  );
}
